export default __webpack_public_path__ + "static/media/info-yellow.c63f4c5b.svg";